// Every react-query key in the app, so a write can invalidate exactly what it
// changed. Keys start with their area, so `{ queryKey: ['comments'] }` matches
// every comment list.
export const queryKeys = {
  me: ['me'],

  taxonomy: ['taxonomy'],
  roots: (kind, maxKnowledge) => ['taxonomy', kind, 'roots', maxKnowledge || null],
  children: (kind, id, maxKnowledge) => ['taxonomy', kind, 'children', id, maxKnowledge || null],
  parents: (kind, id) => ['taxonomy', kind, 'parents', id],
  paths: (kind, id) => ['taxonomy', kind, 'paths', id],
  node: (kind, id) => ['node', kind, id],

  association: (id) => ['association', id],
  comparisons: (associationId, otherDiseaseIds) => ['comparisons', associationId, otherDiseaseIds],
  findingComparisons: (findingId, diseaseIds) => ['finding-comparisons', findingId, diseaseIds],

  // `kind` is "association-references" or "disease-references"
  references: (kind, parentId, measure) => ['references', kind, parentId, measure || null],
  comments: (targetKind, id) => ['comments', targetKind, id],
  replies: (commentId) => ['replies', commentId],
  images: (targetKind, id) => ['images', targetKind, id],
  flags: (targetKind, id, filter) => ['flags', targetKind, id, filter],
};

// The lists and details that show `flag_counts`, refreshed after a flag changes
export const FLAG_COUNT_AREAS = ['node', 'comments', 'replies', 'images', 'references', 'flags'];

export const invalidateAreas = (queryClient, areas) =>
  Promise.all(areas.map((area) => queryClient.invalidateQueries({ queryKey: [area] })));
